import { BehaviorSubject, EMPTY, fromEvent } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import BaseService from './base.service';

const io = require('socket.io-client');

const baseUrl = process.env.REACT_APP_CHAT_SOCKET_URL;
const socketPath = process.env.REACT_APP_CHAT_SOCKET_PATH;

export default class SocketService extends BaseService {
  socket;
  connected$ = new BehaviorSubject(false);

  constructor() {
    super();

    this.connect();
  }

  connect() {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;
    this.disconnect();

    this.socket = io(baseUrl, {
      path: socketPath,
      query: {
        token: accessToken,
      },
      reconnection: true,
      transports: ['websocket'],
    });

    this.socket.on('connect', () => {
      this.connected$.next(true);
    });
    this.socket.on('disconnect', () => this.connected$.next(false));
    this.socket.on('connect_error', (error) => {
      // eslint-disable-next-line no-console
      console.log('CONNECTION ERROR', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  getChannel(channel) {
    return fromEvent(this.socket, channel).pipe(takeUntil(this.connected$.pipe(filter((e) => !e))));
  }

  sendMessage(channel, data) {
    if (this.socket.connected) {
      this.socket.emit(channel, data);
      return;
    }

    const connectListener = () => {
      this.socket.emit(channel, data);
      this.socket.off('connect', connectListener);
    };

    this.socket.once('connect', connectListener);
  }
}
